//// Application Packages
import React from 'react'

//// Application Slices

//// Application Components

//// Carbon Components

//// Carbon Icons

//// Static Constants

//////// Component
const FooterComponent = () => {
    //////// Hooks

    //////// State

    //////// Slices

    //// Slice Data

    //////// Search Params

    //////// Methods

    //////// Functional Methods

    //////// Memoization

    //////// Effects/Side Effects

    //////////////// Render & Return
    return (
        <>
            <div className="page-footer">
                <nav className="page-footer-menu">
                    <ul>
                        <li>
                            <a
                                href="https://www.dms.myflorida.com/support/privacy_statement"
                                target="_blank"
                                rel="noreferrer noopener"
                                aria-label="logout-link"
                                type="link"
                            >
                                Privacy Statement
                            </a>
                        </li>
                        <li className="page-footer-menu-symbol">|</li>
                        <li>
                            <a
                                href="https://flhealthsource.gov/disclaimer/"
                                target="_blank"
                                rel="noreferrer noopener"
                                aria-label="logout-link"
                                type="link"
                            >
                                Disclaimer
                            </a>
                        </li>
                        <li className="page-footer-menu-symbol">|</li>
                        <li>
                            <a
                                href="https://mqawebsupport.wufoo.com/forms/qg787hh02q093j/"
                                target="_blank"
                                rel="noreferrer noopener"
                                aria-label="logout-link"
                                type="link"
                            >
                                Feedback
                            </a>
                        </li>
                        <li className="page-footer-menu-symbol">|</li>
                        <li>
                            <a
                                href="https://www.floridahealth.gov/email-advisory.html"
                                target="_blank"
                                rel="noreferrer noopener"
                                aria-label="logout-link"
                                type="link"
                            >
                                Email Advisory
                            </a>
                        </li>
                    </ul>
                </nav>
                <p className="page-footer-copyright">
                    © {new Date().getFullYear()} FL HealthSource, All Rights
                    Reserved
                </p>
                <p className="page-footer-caption">
                    <strong>Florida Department of Health</strong> | Division of
                    Medical Quality Assurance Web Portal
                </p>
            </div>
        </>
    )
}

export default FooterComponent
